import { EDTEvent } from '@teetsh/app/src/types/edt';
import { Classroom } from '@teetsh/app/src/types/classroom';
import getClassroomsAvailableForThatDay from '@teetsh/app/src/components/EDT/getClassroomsAvailableForThatDay';
import getDay from '@teetsh/app/src/utils/time/getDay';

export function filterEventByClassroomAndDay(
  events: EDTEvent[],
  classrooms: Classroom[],
) {
  return events.filter(e => {
    const matchingClassrooms = e.classroomIds
      .map(clId => classrooms.find(c => c.id === clId))
      .filter(c => c) as Classroom[];
    if (matchingClassrooms.length === 0) {
      return false;
    }
    const filteredClassrooms = getClassroomsAvailableForThatDay(
      matchingClassrooms,
      getDay(e.start),
    );
    return filteredClassrooms.length > 0;
  });
}
